export var ChatMessageDeliveryStatus;
(function (ChatMessageDeliveryStatus) {
    ChatMessageDeliveryStatus["Sending"] = "sending";
    ChatMessageDeliveryStatus["Failed"] = "failed";
})(ChatMessageDeliveryStatus || (ChatMessageDeliveryStatus = {}));
